import { getKeycloak } from './keycloak-instance';

/** Lê uma realm role do token já parseado. Falha fechado se o KC não subiu. */
function hasRealmRole(role: string): boolean {
  try {
    return getKeycloak().hasRealmRole(role);
  } catch {
    return false;
  }
}

/**
 * True when the current operator's Keycloak token carries the `admin` realm role.
 *
 * The backoffice realm authenticates every operator, but only `admin` may see the
 * audit trail (per-user tab + global page). Reads the parsed token synchronously;
 * returns false if Keycloak isn't initialized yet (fail closed).
 */
export function isAdmin(): boolean {
  return hasRealmRole('admin');
}

/**
 * True quando o operador pode gerir o catálogo de instituições e cursos.
 *
 * EU-749 — o catálogo saiu de `admin` e passou a aceitar também
 * `customer-support` (Grupo B do card): é operação de dia a dia do atendimento,
 * não ação destrutiva. A recusa DEFINITIVA continua sendo o 403 do Core
 * (`supportCapabilityGuard`) — esconder o controle na interface não é gate
 * (RN-13). Esta função existe para o inverso: sem ela o operador ganharia a
 * permissão no backend e continuaria sem conseguir CHEGAR na tela, que é a
 * falha silenciosa do EU-571.
 */
export function canManageCatalog(): boolean {
  return hasRealmRole('admin') || hasRealmRole('customer-support');
}

/**
 * True quando o operador pode acionar as ações IRREVERSÍVEIS da Zona de perigo:
 * anonimizar (LGPD) e ativar/desativar conta.
 *
 * EU-749 — espelha o `IRREVERSIBLE_OPS_ROLES` do BFF
 * (`modules/users/interfaces/http/users.routes.ts`). Os dois lados têm que
 * concordar: aqui é só o aviso ao operador, o gate de verdade é o 403 do
 * backend (RN-13). Divergir faz o botão prometer o que a API vai recusar — ou,
 * pior, esconder uma ação que o operador podia fazer.
 */
export function canRunIrreversibleOps(): boolean {
  return hasRealmRole('admin') || hasRealmRole('support-admin');
}
